import cn from 'classnames';
import React from 'react';
import Spinner from '../spinner/Spinner';
import { Step, StepStatus } from './types';

interface Props {
  steps: Step[];
  orientation?: TimeLineOrientation;
}
type TimeLineOrientation = 'horizontal' | 'vertical';

function StepStatusRender(status: { status: StepStatus }) {
  let stepStatus: string = status.status as string;

  switch (stepStatus) {
    case 'NotStarted':
      return <clr-icon shape="circle" aria-label="Not started" />;
    case 'Current':
      return (
        <clr-icon shape="dot-circle" aria-current="true" aria-label="Current" />
      );
    case 'Completed':
      return <clr-icon shape="success-standard" aria-label="Completed" />;
    case 'Error':
      return <clr-icon shape="error-standard" aria-label="Error" />;
    case 'InProgress':
      return (
        <span>
          <Spinner size={'md'} />
        </span>
      );
    default:
      return <clr-icon shape="circle" aria-label="Not started" />;
  }
}

const TimeLine = React.forwardRef<HTMLUListElement, Props>((props, ref) => {
  const { steps, orientation = 'horizontal' } = props;
  const classNames = cn('clr-timeline', {
    'clr-timeline-vertical': orientation === 'vertical'
  });
  return (
    <ul ref={ref} className={classNames}>
      {steps.map((step, index) => (
        <li
          className="clr-timeline-step disabled"
          key={step.stepHeader + index}>
          <div className="clr-timeline-step-header">{step.stepHeader}</div>
          <StepStatusRender status={step.status} />
          <div className="clr-timeline-step-body">
            <span className="clr-timeline-step-title">{step.stepTitle}</span>
            <span className="clr-timeline-step-description">
              {step.stepDescription}
            </span>
            {step.onClick ? (
              <button className="btn btn-sm" onClick={step.onClick}>
                {step.stepActionTitle ? step.stepActionTitle : 'action'}
              </button>
            ) : null}
          </div>
        </li>
      ))}
    </ul>
  );
});

export default TimeLine;
